<template>
  <v-container>
    <v-row justify="center">
      <v-col lg="8">
        <MissionListWidget :isLoading="isLoading" canDelete canAdd />
      </v-col>
    </v-row>
  </v-container>
</template>
<style lang="sass" scoped></style>
<script>
// @ is an alias to /src
import MissionListWidget from "@/components/MissionListWidget.vue";

export default {
  name: "MissionsComponent",
  components: {
    MissionListWidget
  },
  data: () => ({
    isLoading: false
  }),
  async mounted() {}
};
</script>
